// BUG-051 / BUG-056 — the copy for "this screen could not READ its data".
//
// In the `common` namespace, not `admin`: every screen that needs it already binds
// `useT("common")` for extractApiError (which translates the refusals it knows by code),
// and the sentence is the same wherever a read fails. One wording, five screens, no drift.
//
// The reassurance is the load-bearing half. The defect these keys close is a screen that
// told the practitioner "No products yet" when the request had merely failed; the natural
// reaction is to assume the data is gone and re-create it. Saying "nothing has been
// changed or deleted" is what stops that.
//
// `errors.loadFailedShort` is the same fact with no room for the reassurance: it labels a
// single summary card on Admin -> Overview, where the number it replaces is a dash. The
// server's own message is deliberately NOT shown there — six cards side by side leave no
// space for prose, and the retry beside it is the only action available anyway.
export default {
  fr: {
    "errors.loadFailed":
      "Les données de cette page n’ont pas pu être chargées. C’est un problème de chargement — rien n’a été modifié ni supprimé.",
    "errors.loadFailedShort": "Chargement impossible",
    "actions.retry": "Réessayer",
  },
  en: {
    "errors.loadFailed":
      "This page's data could not be loaded. This is a loading problem — nothing has been changed or deleted.",
    "errors.loadFailedShort": "Could not load",
    "actions.retry": "Try again",
  },
  es: {
    "errors.loadFailed":
      "No se pudieron cargar los datos de esta página. Es un problema de carga: no se ha modificado ni eliminado nada.",
    "errors.loadFailedShort": "No se pudo cargar",
    "actions.retry": "Volver a intentar",
  },
};
